import { render, staticRenderFns } from "./DocumentContentView.vue?vue&type=template&id=39ea95c4"
import script from "./DocumentContentView.vue?vue&type=script&lang=js"
export * from "./DocumentContentView.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentView.vue?vue&type=style&index=0&id=39ea95c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports